module.exports = "label{width:calc(8px * 12)}.trimmedValue{max-width:calc(8px * 50);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n"